import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ADMIN } from '../../Routes';
import styled from 'styled-components';
import Notification from '../StoraEnsoComponents/Notification';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tag from '../StoraEnsoComponents/Tag';
import Loading from '../Loading';
import UserLog from '../UserLog';
import { getProfile } from '../../services/userService';
import Button from '../StoraEnsoComponents/Button';
import { ContainerWrapper, Container } from '../Container';

const Wrapper = styled.div`
    background-color: #fff;
    text-align: left;

    h5 {
      margin-bottom: 16px;
    }
`;

const Row = styled.div`
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const ProfileInfoWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    background-color: #f8f8f9;
    padding: 32px 16px;
    /* max-width: 75%; */
    column-gap: 16px;
    margin-bottom: 50px;

    @media screen and (min-width: 768px) {
      grid-template-columns: 150px 1fr;
    }
`;

const IconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    color: #9a9aa4;
    margin-bottom: 1rem;
`;

const NameGrid = styled(Row)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;

    @media screen and (min-width: 992px) {
      grid-template-columns: minmax(150px, max-content) minmax(150px, max-content) 1fr;
    }
`;

const Label = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 0.25rem;
`;

const Value = styled.span`
    display: block;
    margin-bottom: 0.25rem;
`;

const Name = styled(Value)`
    &::first-letter {
        text-transform: uppercase;
    }
`;

const TagWrapper = styled.div`

    div {
        font-size: 14px;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
    }
`;

const ErrorWrapper = styled.div`
  margin-bottom: 1rem;
  max-width: 75%;
`;

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-size: 14px;
  grid-column: span 2;
  margin-top: 8px;

  a {
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) {
    grid-column: span 1;
    margin-top: 0;

    a {
      margin: 0;
    }
  }
`;


// TODO
// - mobile view
function UserProfilePage() {
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
      setLoading(true);

      getProfile()
          .then(data => setUserData(data))
          .catch(err => {
              setLoadingError(err);
          })
          .then(() => setLoading(false));
  }, []);

  return (
    <Wrapper>
      <ContainerWrapper>
        <Container>
            <h5 className="se-font-size-h-5">User Profile</h5>
            {
              loading && (
                  <Loading message="Loading user profile data..." />
              )
            }

            {
            loadingError && (
              <ErrorWrapper>
                  <Notification kind="negative" onClose={() => setLoadingError(false)}>An error has occurred while loading user profile data!</Notification>
              </ErrorWrapper>
            )}

            {
              userData && (
                <ProfileInfoWrapper>
                  <IconWrapper>
                      <FontAwesomeIcon
                          icon={['fas', 'user-circle']}
                          size="5x"
                      />
                  </IconWrapper>
                  <div>
                    <NameGrid>
                        <div>
                            <Label>Firstname</Label>
                            <Name>{userData.firstname}</Name>
                        </div>
                        <div>
                            <Label>Surname</Label>
                            <Name>{userData.surname}</Name>
                        </div>
                        {
                          userData?.admin && (
                            <ActionsWrapper>
                                <Link to={ADMIN}>
                                    <Button kind="attention" onClick={() => {}}>ADMIN DASHBOARD</Button>
                                </Link>
                            </ActionsWrapper>
                          )
                        }
                    </NameGrid>
                    <Row>
                        <Label>Email</Label>
                        <Value id="UserEmail">{userData.email}</Value>
                    </Row>
                    <Row>
                        <Label>Locations</Label>
                        <TagWrapper id="Locations">
                            {
                              userData.locations?.length > 0 ?
                                userData.locations?.map(el => (
                                    <Tag key={el.id}>{el.name}</Tag>
                                ))
                                : '-'
                            }
                        </TagWrapper>
                    </Row>
                  </div>
                </ProfileInfoWrapper>
              )
            }
            <UserLog userData={userData} />
        </Container>
      </ContainerWrapper>
    </Wrapper>
  );
}

export default UserProfilePage;